<template>

  <section :class="pageCss">


    <div class="wrapper__inner--narrow">

      <section>

        <div :style="'background-image:url('+heroImage+')'"></div>
        <div>

          <!-- <h2>Read the Next Chapter</h2> -->
          <p v-html="content.title"></p>
          <button class="default" @click="navigateThroughPages(1)">
            Read now
            <span>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.1 19.3" style="enable-background:new 0 0 23.1 19.3;" xml:space="preserve">
                <polygon points="21.5,8.2 13.8,0 12.2,1.6 18.8,8.6 0,8.6 0,10.8 18.9,10.8 12.5,17.7 14.1,19.3 23.1,9.7 "/>
              </svg>
            </span>
          </button>

        </div>

      </section>

    </div>
  </section>

</template>

<script>

  // mixins
  import NavigatePages from '@/mixins/navigatePages';

  export default {
    name: 'SectionNextPage',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    mixins: [ NavigatePages ],
    computed: {

      pageCss() {
        return `content content__next-page`;
      },

      heroImage() {

        return this.content.heroImage.thumbnail || this.content.heroImage.loaded

      }

    }
  };
</script>